import {
  PATH_MISSION_SERVICE_USAGES_EDIT,
  PATH_MISSION_SERVICE_USAGES_EDIT_SUB_MISSION,
} from '../../app/constants/paths.constant';

import { SubMissionPricingCards } from './components/SubMissionPricingCards';
import { SubMissionPricingDetail } from './components/SubMissionPricingDetail';
import type { SubMissionPricingRoutes } from './components/SubMissionPricingCards';
import { pricedGroupsOf } from './hooks/useSubMissionsPricing.hook';
import { buildSubMissionTotalCalculation } from './utils/sub-mission-total.util';
import type { GroupTotalCalculationMap } from '../../utils/build-group-total-calculation-map.util';
import type { SubMissionPricing } from './types/sub-mission-pricing.type';

interface Props {
  // The options are chosen in the edition mode only.
  readonly isEditionMode: boolean;
  // The group totals of the collaboration.
  readonly groupTotalCalculationMap: GroupTotalCalculationMap;
  readonly subMissions: readonly SubMissionPricing[];
}

const EDITION_ROUTES: SubMissionPricingRoutes = {
  page: PATH_MISSION_SERVICE_USAGES_EDIT,
  detail: PATH_MISSION_SERVICE_USAGES_EDIT_SUB_MISSION,
};

export const SubMissionsPricing = ({
  groupTotalCalculationMap,
  isEditionMode,
  subMissions,
}: Readonly<Props>) => (
  <SubMissionPricingCards
    consultInNewTab={isEditionMode}
    items={subMissions.map((subMission) => ({
      subMission,
      totalCalculation: buildSubMissionTotalCalculation({
        groups: pricedGroupsOf(subMission.pricing),
        groupTotalCalculationMap,
        selectedOptionGroupIds: subMission.pricing.selectedOptionGroupIds,
      }),
      detail: (
        <SubMissionPricingDetail
          isEditionMode={isEditionMode}
          subMission={subMission}
        />
      ),
    }))}
    routes={isEditionMode ? EDITION_ROUTES : undefined}
  />
);
